export default __webpack_public_path__ + "static/media/developerActivity.2c0445ca.svg";